import React from "react";
import style from "./Inputs.module.scss";

const TextInput = ({ label, name, value, onChange, placeholder, maxLength = 100, required }) => {
  return (
    <div className={style.inputContainer}>
      <label className={style.label}>
        {label} 
        {required&&<span className={style.required}>*</span>}
        
      </label>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        placeholder={placeholder}
        className={style.inputField}
      />
    </div>
  );
};

export default TextInput;
